// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/admin_seller",
    element: lazy(() => import("../pages/SellerTemplate")),
  },
  {
    path: "/admin_seller/view/:sellerId",
    element: lazy(() => import("../pages/SellerTemplate/SellerView")),
  },
  {
    path: "/admin_seller/create",
    element: lazy(() => import("../pages/SellerTemplate/CreateSeller")),
  },
  {
    path: "/admin_seller/create/:sellerId",
    element: lazy(() => import("../pages/SellerTemplate/CreateSeller")),
  },
  {
    path: "/admin_seller/edit/:sellerId",
    element: lazy(() => import("../pages/SellerTemplate/CreateSeller/EditRoute")),
  },
  {
    path: "/admin_seller/editSeller/:sellerId",
    element: lazy(() => import("../pages/SellerTemplate/EditSeller")),
  },
];

export default routes;
